export default __webpack_public_path__ + "static/trace_01-ee5d0637f50fb1b9a7e775489de38a95.png";